import { render, staticRenderFns } from "./NoDebtCertificate.vue?vue&type=template&id=96960db0&"
import script from "./NoDebtCertificate.vue?vue&type=script&lang=js&"
export * from "./NoDebtCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports